<mat-card class="echo-modal">
  <form [formGroup]="echoFormGroup">
    <mat-form-field class="tl-full-width" appearance="standard">
      <mat-label>Say something about this post</mat-label>
      <mat-post-input formControlName="echo"></mat-post-input>
      <mat-error *ngIf="echoFormGroup.get('echo').hasError('required')">
        You must write something.
      </mat-error>
    </mat-form-field>
  </form>
  <mat-card class="echo-modal">
    <div class="d-flex">
      <!-- Profile Picture -->
      <div>
        <img [src]="data?.post?.author?.photoURL?.trim() || './assets/images/profile.jpg'" class="tl-profile">
      </div>

      <!-- Name -->
      <div>
        <div class="tl-name">
          {{data?.post?.echoContent?.originalPost?.author?.name || data?.post?.author?.name}}
          <span class="tl-username text-success">
            @{{data?.post?.echoContent?.originalPost?.author?.handle || data?.post?.author?.handle}}
          </span>
        </div>
        <!-- Published Date -->
        <div class="tl-date">
          <i class="fas fa-clock mr-1"></i>
          <span>some time ago</span>
        </div>
      </div>
    </div>
    <!-- Post Content -->
    <div class="">
      <h5 class="tl-title"></h5>
      <p class="tl-post">
        <span>
           <read-article>
          <markdown ngPreserveWhitespaces *ngIf="!data?.post?.echoContent?.originalPost?.body">
            {{repostRepostBody}}
          </markdown>
           </read-article>
          </span>

        <span *ngIf="data?.post?.echoContent?.originalPost?.body">
          <read-article>
            <markdown ngPreserveWhitespaces>
           {{repostOriginalBody}}
         </markdown>
          </read-article>
        </span>
      </p>
    </div>
  </mat-card>

  <div class="d-flex justify-content-between mt-3">
    <button mat-button color="accent" (click)="closeDialog()">Dismiss</button>
    <button mat-button color="primary" (click)="createEcho()" cdkFocusInitial>Rescribe</button>
  </div>

</mat-card>
